// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"505":"188570ed","3378":"03da15cc","4034":"1baed54b","9395":"f444a95e"}[chunkId] + ".chunk.css";
};